import $ from 'jquery';
import Util from '../utils/ui';
import * as CONST from '../utils/constants';

class LFCYLandingPage {
	constructor() {
		this.expandStat = $('.js-expand-stat-item');
		this.$expandedContent = $('.js-expanded-stat-item');
		this.$closeExpandedContent = $('.js-close-expanded-stat-item');
		this.$sectionImpactList = $('.cta-plus-link');
	}

	init() {
		this.bindEvents();
	}

	bindEvents() {
		$('body').on('click', '.js-expand-stat-item', e => { this.toggleExpandedContent(e); });
		this.$closeExpandedContent.on('click', e => { this.closeExpandedContent(e); });
	}

	closeExpandedContent(e) {
		this.expandStat.removeClass('active');
		$('.section-impact-expanded').toggle();
		$('.section-impact-expanded').removeClass('active');
		$('body').removeClass('stat-open');
		$('.section-impact-wrap').css('opacity', '0');
		if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
			//$('html').scrollTop(this.$scrollTop);
		}

		this.$expandedContent.html('');
	}

	toggleExpandedContent(e) {
		const target = $(e.currentTarget);
		const expanded = $(target).closest('.stat-item-wrapper').find('.stat-story-callout-expand').html();	
		this.expandStat.removeClass('active');
		$(target).addClass('active');

		$('.section-impact-expanded').show();
		$('.section-impact-expanded').addClass('active');
		const delay = (Util.getViewPort() === CONST.ViewPort.Desktop) ? 800 : 100;
		setTimeout(() => {
			$('.section-impact-wrap').css('opacity', '1');
		}, delay);

		this.$scrollTop = $('html').scrollTop();
		this.$expandedContent.html($(expanded));
	}
}
export default LFCYLandingPage;
$(() => {
	const lfcyStatItems = new LFCYLandingPage();
	lfcyStatItems.init();
});